import React from 'react';
/**
 * SoundbarIcon
 *
 * Simple svg icon.
 * As this is only for a temporal landing page it is not moved to DS.
 */
const SoundbarIcon = () => (
  <svg
    width="100%"
    height="29"
    viewBox="0 0 235 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="1.75543"
      y1="11.337"
      x2="1.75543"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="6.77716"
      y1="11.337"
      x2="6.77716"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="11.7989"
      y1="11.337"
      x2="11.7989"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="16.8207"
      y1="11.337"
      x2="16.8207"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="21.8424"
      y1="11.337"
      x2="21.8424"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="26.8641"
      y1="8.82611"
      x2="26.8641"
      y2="20.5435"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="31.8859"
      y1="0.456543"
      x2="31.8859"
      y2="28.9131"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="36.9077"
      y1="5.47827"
      x2="36.9077"
      y2="23.8913"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="41.9294"
      y1="5.47827"
      x2="41.9294"
      y2="23.8913"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="46.9511"
      y1="0.456543"
      x2="46.9511"
      y2="28.9131"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="51.9728"
      y1="8.40765"
      x2="51.9728"
      y2="20.962"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="56.9946"
      y1="8.40765"
      x2="56.9946"
      y2="20.962"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="62.0163"
      y1="11.337"
      x2="62.0163"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="67.038"
      y1="11.337"
      x2="67.038"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="72.0598"
      y1="5.47827"
      x2="72.0598"
      y2="23.8913"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="77.0815"
      y1="0.456543"
      x2="77.0815"
      y2="28.9131"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="82.1032"
      y1="0.456543"
      x2="82.1032"
      y2="28.9131"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="87.1251"
      y1="5.47827"
      x2="87.1251"
      y2="23.8913"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="92.1468"
      y1="2.96741"
      x2="92.1468"
      y2="26.4022"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="97.1685"
      y1="2.96741"
      x2="97.1685"
      y2="26.4022"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="102.19"
      y1="1.29352"
      x2="102.19"
      y2="28.0761"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="107.212"
      y1="1.29352"
      x2="107.212"
      y2="28.0761"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="112.234"
      y1="11.337"
      x2="112.234"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="117.255"
      y1="11.337"
      x2="117.255"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="122.277"
      y1="5.05981"
      x2="122.277"
      y2="24.3098"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="127.299"
      y1="5.05981"
      x2="127.299"
      y2="24.3098"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="132.321"
      y1="5.05981"
      x2="132.321"
      y2="24.3098"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="137.342"
      y1="11.337"
      x2="137.342"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="142.364"
      y1="11.337"
      x2="142.364"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="147.386"
      y1="5.47827"
      x2="147.386"
      y2="23.8913"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="152.408"
      y1="0.456543"
      x2="152.408"
      y2="28.9131"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="157.429"
      y1="0.456543"
      x2="157.429"
      y2="28.9131"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="162.451"
      y1="5.47827"
      x2="162.451"
      y2="23.8913"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="167.473"
      y1="2.96741"
      x2="167.473"
      y2="26.4022"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="172.495"
      y1="2.96741"
      x2="172.495"
      y2="26.4022"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="177.516"
      y1="1.29352"
      x2="177.516"
      y2="28.0761"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="182.538"
      y1="1.29352"
      x2="182.538"
      y2="28.0761"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="187.56"
      y1="11.337"
      x2="187.56"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="192.581"
      y1="11.337"
      x2="192.581"
      y2="18.0326"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="197.603"
      y1="5.05981"
      x2="197.603"
      y2="24.3098"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="202.625"
      y1="5.05981"
      x2="202.625"
      y2="24.3098"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="207.647"
      y1="5.05981"
      x2="207.647"
      y2="24.3098"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="212.669"
      y1="5.47827"
      x2="212.669"
      y2="23.8913"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="217.69"
      y1="0.456543"
      x2="217.69"
      y2="28.9131"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="222.712"
      y1="0.456543"
      x2="222.712"
      y2="28.9131"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="227.734"
      y1="5.47827"
      x2="227.734"
      y2="23.8913"
      stroke="white"
      strokeWidth="2.51087"
    />
    <line
      x1="232.755"
      y1="5.05981"
      x2="232.755"
      y2="24.3098"
      stroke="white"
      strokeWidth="2.51087"
    />
  </svg>
);

export default SoundbarIcon;
